import { equals } from 'ramda';
/**
 * Useful for chains .filter(onlyUnique).reduce...
 * In other cases can be used ramda uniq.
 */
export const onlyUnique = (value, index, self) => {
    const foundIndex = self.findIndex(el => equals(el, value));
    return foundIndex === index;
};
